// src/utils/validators.js

/**
 * Valider les données de connexion
 */
export const validateLoginForm = (email, password) => {
    const errors = {};
  
    // Email
    if (!email) {
      errors.email = 'L\'email est requis';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errors.email = 'Email invalide';
    }
  
    // Password
    if (!password) {
      errors.password = 'Le mot de passe est requis';
    } else if (password.length < 6) {
      errors.password = 'Le mot de passe doit contenir au moins 6 caractères';
    }
  
    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  };
  
  /**
   * Valider les données d'inscription
   */
  export const validateRegisterForm = (data) => {
    const errors = {};
  
    // Nom
    if (!data.name || data.name.trim().length === 0) {
      errors.name = 'Le nom complet est requis';
    } else if (data.name.trim().length < 3) {
      errors.name = 'Le nom doit contenir au moins 3 caractères';
    }
  
    // Email
    if (!data.email) {
      errors.email = 'L\'email est requis';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      errors.email = 'Email invalide';
    }
  
    // Téléphone
    if (!data.phone) {
      errors.phone = 'Le numéro de téléphone est requis';
    } else if (!/^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/.test(data.phone)) {
      errors.phone = 'Numéro de téléphone invalide';
    }
  
    // Mot de passe
    if (!data.password) {
      errors.password = 'Le mot de passe est requis';
    } else if (data.password.length < 8) {
      errors.password = 'Le mot de passe doit contenir au moins 8 caractères';
    } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(data.password)) {
      errors.password = 'Le mot de passe doit contenir au moins une majuscule, une minuscule et un chiffre';
    }
  
    // Confirmation mot de passe
    if (!data.confirmPassword) {
      errors.confirmPassword = 'Veuillez confirmer le mot de passe';
    } else if (data.password !== data.confirmPassword) {
      errors.confirmPassword = 'Les mots de passe ne correspondent pas';
    }
  
    // Zone de livraison
    if (!data.delivery_zone) {
      errors.delivery_zone = 'La zone de livraison est requise';
    }
  
    // Type de véhicule
    if (!data.vehicle_type) {
      errors.vehicle_type = 'Le type de véhicule est requis';
    }
  
    // Numéro de permis (optionnel mais si fourni, doit être valide)
    if (data.driver_license_number && data.driver_license_number.length < 5) {
      errors.driver_license_number = 'Numéro de permis invalide';
    }
  
    // Contact d'urgence
    if (!data.emergency_contact) {
      errors.emergency_contact = 'Le contact d\'urgence est requis';
    } else if (!/^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/.test(data.emergency_contact)) {
      errors.emergency_contact = 'Numéro d\'urgence invalide';
    }
  
    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  };
  
  /**
   * Valider les données de profil
   */
  export const validateProfileForm = (data) => {
    const errors = {};
  
    // Nom
    if (!data.name || data.name.trim().length === 0) {
      errors.name = 'Le nom est requis';
    } else if (data.name.trim().length < 3) {
      errors.name = 'Le nom doit contenir au moins 3 caractères';
    }
  
    // Téléphone
    if (!data.phone) {
      errors.phone = 'Le téléphone est requis';
    } else if (!/^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/.test(data.phone)) {
      errors.phone = 'Numéro de téléphone invalide';
    }
  
    // Zone de livraison
    if (!data.delivery_zone) {
      errors.delivery_zone = 'La zone de livraison est requise';
    }
  
    // Type de véhicule
    if (!data.vehicle_type) {
      errors.vehicle_type = 'Le type de véhicule est requis';
    }
  
    // Contact d'urgence
    if (!data.emergency_contact) {
      errors.emergency_contact = 'Le contact d\'urgence est requis';
    } else if (!/^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/.test(data.emergency_contact)) {
      errors.emergency_contact = 'Numéro d\'urgence invalide';
    }
  
    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  };
  
  /**
   * Valider un fichier image
   */
  export const validateImageFile = (file) => {
    const errors = [];
  
    // Vérifier le type
    const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      errors.push('Format de fichier non supporté. Utilisez JPG, PNG ou WebP.');
    }
  
    // Vérifier la taille (max 5MB)
    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      errors.push('Le fichier est trop volumineux. Taille maximale : 5MB.');
    }
  
    return {
      isValid: errors.length === 0,
      errors
    };
  };
  
  /**
   * Valider une raison d'échec de livraison
   */
  export const validateFailureReason = (reason) => {
    if (!reason || reason.trim().length === 0) {
      return {
        isValid: false,
        error: 'Veuillez fournir une raison'
      };
    }
  
    if (reason.trim().length < 10) {
      return {
        isValid: false,
        error: 'La raison doit contenir au moins 10 caractères'
      };
    }
  
    return { isValid: true };
  };
  
  /**
   * Valider les coordonnées GPS
   */
  export const validateGPSCoordinates = (latitude, longitude) => {
    const errors = {};
  
    if (latitude === null || latitude === undefined) {
      errors.latitude = 'Latitude requise';
    } else if (latitude < -90 || latitude > 90) {
      errors.latitude = 'Latitude invalide';
    }
  
    if (longitude === null || longitude === undefined) {
      errors.longitude = 'Longitude requise';
    } else if (longitude < -180 || longitude > 180) {
      errors.longitude = 'Longitude invalide';
    }
  
    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  };
  
  export default {
    validateLoginForm,
    validateRegisterForm,
    validateProfileForm,
    validateImageFile,
    validateFailureReason,
    validateGPSCoordinates
  };